webpackJsonp([14357656358427],{

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _TextBlock = __webpack_require__(24);
	
	var _TextBlock2 = _interopRequireDefault(_TextBlock);
	
	var _ProjectDetails = __webpack_require__(27);
	
	var _ProjectDetails2 = _interopRequireDefault(_ProjectDetails);
	
	var _ProjectHeader = __webpack_require__(28);
	
	var _ProjectHeader2 = _interopRequireDefault(_ProjectHeader);
	
	var _SingleImage = __webpack_require__(29);
	
	var _SingleImage2 = _interopRequireDefault(_SingleImage);
	
	var _AHref = __webpack_require__(17);
	
	var _AHref2 = _interopRequireDefault(_AHref);
	
	var _kincarePreview_ = __webpack_require__(468);
	
	var _kincarePreview_2 = _interopRequireDefault(_kincarePreview_);
	
	var _kincareDesktop_ = __webpack_require__(467);
	
	var _kincareDesktop_2 = _interopRequireDefault(_kincareDesktop_);
	
	var _kincareRoadmapping = __webpack_require__(469);
	
	var _kincareRoadmapping2 = _interopRequireDefault(_kincareRoadmapping);
	
	__webpack_require__(343);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KinCare = function (_Component) {
	  _inherits(KinCare, _Component);
	
	  function KinCare() {
	    _classCallCheck(this, KinCare);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  KinCare.prototype.render = function render() {
	    var children = this.props.children;
	
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_ProjectHeader2.default, {
	        heading: 'A new platform to support the leaders of in-home care',
	        client: 'KinCare'
	      }),
	      _react2.default.createElement(_SingleImage2.default, { img: _kincarePreview_2.default, margin: true }),
	      _react2.default.createElement(
	        _ProjectDetails2.default,
	        {
	          role: 'User experience designer',
	          client: 'KinCare',
	          agency: 'Pollen',
	          agencylink: 'https://wwww.pollen.com.au',
	          deliverables: 'User research, site reviews, competitor reviews, analytics and optimisation, information architecture, wireframes, user flows, prototyping'
	        },
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'Background'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'KinCare is one of Australia\u2019s largest in-home, aged-care and disability support providers. In early 2017, ',
	          _react2.default.createElement(
	            _AHref2.default,
	            { url: 'https://agedcare.health.gov.au/aged-care-reform/home-care/home-care-packages-reform' },
	            'as choice for in-home aged care providers became customer-directed'
	          ),
	          ', Pollen partnered with KinCare to refresh their brand and completely overhaul their website \u2013 the forefront of the KinCare staff and customer experience.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Alongside the team at Pollen, I worked across strategy, design and development to build and optimise a new website that better supported the KinCare customer journey. '
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            _AHref2.default,
	            { url: 'https://wwww.kincare.com.au' },
	            'Visit the KinCare website'
	          )
	        )
	      ),
	      _react2.default.createElement(_SingleImage2.default, { img: _kincareDesktop_2.default, margin: true }),
	      _react2.default.createElement(
	        _TextBlock2.default,
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'User experience design and discovery'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'To better understand the KinCare customer and business, I worked with Pollen\u2019s Experience Design Director ',
	          _react2.default.createElement(
	            _AHref2.default,
	            { url: 'https://au.linkedin.com/in/adrianwiggins' },
	            'Adrian Wiggins'
	          ),
	          ' to define, develop and deliver a range of user research, including interviews, personas, customer journey maps, flow maps, and analytics reviews.'
	        )
	      ),
	      _react2.default.createElement(_SingleImage2.default, { img: _kincareRoadmapping2.default, small: true, caption: 'Picture by Jeremy Simons http://www.jeremysimons.com.au/' }),
	      _react2.default.createElement(
	        _TextBlock2.default,
	        null,
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'A new modular platform'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'This research supported the design of wireframes, prototypes and information architecture which laid the foundation for a robust new platform that accommodated for the range of new content that Pollen developed alongside the new site. The new platform uses a number of module-based templates for flexible page creation.'
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'New features and pages'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I was also responsible for strategy and user experience design for a number of new pages and features.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I developed the user experience of 16,000 dynamic pages of new content that helped improve search engine visibility, drive traffic and generate leads.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'I also developed the user experience of service pages that helped explain the breadth and depth of KinCare\'s services to their customers.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Most recently, I crafted the strategy and experience of KinCare\u2019s flexible respite calculator, a new tool that demonstrates how flexible respite can be easily tailored to the needs of a carer and care recipient.'
	        ),
	        _react2.default.createElement(
	          'h2',
	          { className: 'h6' },
	          'Results'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Over the course of a year, we drove an increase in online enquiries by potential customers and saw significant improvements of key engagement metrics including:'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          _react2.default.createElement(
	            'li',
	            null,
	            '\u2013 Decreased bounce rate by 16%'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            '\u2013 Increase in pages per session by 22%'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            '\u2013 Increase in time on site by 33%'
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            '\u2013 Increased SEO visibility by four figures, including increased traffic to careers pages by 240%'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Pollen and KinCare continue to work together to evolve their digital business. The website just one part of KinCare\u2019s larger, ongoing evolution as a first-rank provider of in-home, aged care and disability support services.'
	        )
	      )
	    );
	  };
	
	  return KinCare;
	}(_react.Component);
	
	KinCare.propTypes = {
	  children: _react.PropTypes.node.isRequired
	};
	
	exports.default = KinCare;
	module.exports = exports['default'];

/***/ }),

/***/ 343:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/kincare-desktop_1600.51c5ff43.jpg";

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/kincare-preview_1600.d443945c.jpg";

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/kincare-roadmapping.c29938b4.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-kincare-index-js-beece1a98f75c00400b5.js